import { render } from "./JobProgress.vue?vue&type=template&id=65fa6da3"
import script from "./JobProgress.vue?vue&type=script&lang=js"
export * from "./JobProgress.vue?vue&type=script&lang=js"

import "./JobProgress.vue?vue&type=style&index=0&id=65fa6da3&lang=scss"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__